/* Banana UI helpers: collection description clamp + product page sticky add to cart */
(function () {
  'use strict';

  /* ---------- Collection description clamp ---------- */
  function clamp() {
    document.querySelectorAll('[data-collection-description]').forEach(function (el) {
      if (el.dataset.biClamped) return;
      el.dataset.biClamped = '1';
      el.classList.add('bi-desc');
      if (el.scrollHeight > 160) {
        el.classList.add('bi-desc--clamp');
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bi-desc__toggle'; b.textContent = 'Read more';
        b.addEventListener('click', function () {
          var open = el.classList.toggle('is-open');
          b.textContent = open ? 'Show less' : 'Read more';
        });
        el.parentNode.insertBefore(b, el.nextSibling);
      }
    });
  }

  /* ---------- Product page: sticky add to cart ---------- */
  function product() {
    var atc = document.querySelector('[data-product-atc]');
    if (!atc || document.body.dataset.biProduct) return;
    document.body.dataset.biProduct = '1';

    var titleEl = document.querySelector('.product-title');
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var bar = document.createElement('div');
    bar.className = 'bi-sticky-atc';
    bar.innerHTML =
      '<div class="bi-sticky-atc__info"><div class="bi-sticky-atc__title"></div><div class="bi-sticky-atc__price"></div></div>' +
      '<button type="button" class="bi-sticky-atc__btn">Add to cart</button>';
    bar.querySelector('.bi-sticky-atc__title').textContent = title;
    document.body.appendChild(bar);

    function priceText() {
      var cur = document.querySelector('.product-pricing .price__current:not(.price__current--hidden) > .money');
      if (!cur) cur = document.querySelector('.product-pricing .price__current .money');
      return cur ? cur.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function sync() {
      bar.querySelector('.bi-sticky-atc__price').textContent = priceText();
      var disabled = atc.disabled || atc.getAttribute('aria-disabled') === 'true';
      bar.querySelector('.bi-sticky-atc__btn').textContent = disabled ? (atc.textContent.trim() || 'Unavailable') : 'Add to cart';
      bar.classList.toggle('is-disabled', !!disabled);
    }
    sync();
    new MutationObserver(sync).observe(atc.closest('form') || document.body, { subtree: true, childList: true, attributes: true, characterData: true });
    var pricing = document.querySelector('.product-pricing');
    if (pricing) new MutationObserver(sync).observe(pricing, { subtree: true, childList: true, attributes: true, characterData: true });

    var form = atc.closest('form');
    var hasOptions = form && form.querySelector('select, input[type=radio]');
    bar.querySelector('.bi-sticky-atc__btn').addEventListener('click', function () {
      if (bar.classList.contains('is-disabled')) return;
      if (hasOptions) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      else { atc.click(); }
    });

    /* Show the bar only once the main button has scrolled off the top of the screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var scrolledPast = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && scrolledPast);
      }, { threshold: 0 }).observe(atc);
    }
  }

  function init() { clamp(); product(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
